
















































// vue
import { defineComponent, ref, Ref, computed } from '@vue/composition-api'

// componnents
import { PageHeader } from '@/components'
import { Modal } from '@/components/general'
import { AdvanceTypesTableList, AdvanceTypeFormCreateEdit } from '@/components/config'

// services
import { AdvanceTypesService } from '@/services/config'

// models
import { Paginator } from '@/models'
import { AdvanceType, AdvanceTypeForm } from '@/models/config'

// utils
import { loading, alerts } from '@/utils'

// constants
import { actionFormTypes } from '@/constants'

const advanceTypeDefault: AdvanceTypeForm = {
  name: '',
  apply_afp: false,
  is_active: null
}

export default defineComponent({
  name: 'AdvanceTypesIndex',
  components: {
    PageHeader,
    AdvanceTypesTableList,
    Modal,
    AdvanceTypeFormCreateEdit
  },
  setup () {
    const showModal = ref(false)
    const title = 'Tipos de Adelantos'
    const actionForm = ref(actionFormTypes)
    const idEdit: Ref<number|null> = ref(null)
    const titleModal = computed(() => {
      if (actionForm.value === 'update') {
        return 'Editar Tipo de Adelanto'
      }
      return 'Crear Tipo de Adelanto'
    })
    const items = [
      {
        text: 'Dashboard'
      },
      {
        text: 'Tipos de Adelanto',
        active: true
      }
    ]
    const pagination: Ref<Paginator> = ref({
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
    })
    const advanceType: Ref<AdvanceTypeForm> = ref(advanceTypeDefault)
    const advanceTypes: Ref<AdvanceType[]> = ref([])
    const getAdvanceTypesWithPagination = async () => {
      loading('show')
      const res = await AdvanceTypesService.getWithPagination(pagination.value.perPage, pagination.value.currentPage)
      pagination.value = res.pagination
      advanceTypes.value = res.objects
      loading('hide')
    }
    getAdvanceTypesWithPagination()
    const addNew = () => {
      actionForm.value = 'save'
      showModal.value = true
      advanceType.value = {
        ...advanceTypeDefault
      }
    }
    const saveSuccess = () => {
      showModal.value = false
      actionForm.value = 'save'
      advanceType.value = {
        ...advanceTypeDefault
      }
      idEdit.value = null
      getAdvanceTypesWithPagination()
    }
    const editItem = (item: AdvanceType) => {
      advanceType.value = {
        name: item.name,
        apply_afp: item.apply_afp,
        is_active: item.is_active
      }
      idEdit.value = Number(item.id)
      actionForm.value = 'update'
      showModal.value = true
    }

    const deleteItem = async (item: AdvanceType) => {
      const msg = `Seguro que desea eliminar el Tipo de Adelanto: ${item.name}`
      const confirm = await alerts.confirm(msg)
      if (confirm) {
        loading('show')
        await AdvanceTypesService.delete(item.id)
        alerts.success()
        getAdvanceTypesWithPagination()
      }
    }

    const changeStatus = async (item: AdvanceType) => {
      loading('show')
      await AdvanceTypesService.update(Number(item.id), {
        name: item.name,
        apply_afp: item.apply_afp,
        is_active: !item.is_active
      })
      loading('hide')
      getAdvanceTypesWithPagination()
    }

    const changePage = (page: number) => {
        pagination.value.currentPage = page
        getAdvanceTypesWithPagination()
    }

    const changePerPage = (perPage: number) => {
        pagination.value.perPage = perPage
        pagination.value.currentPage = 1
        getAdvanceTypesWithPagination()
    }

    return {
      items,
      title,
      addNew,
      showModal,
      titleModal,
      advanceType,
      saveSuccess,
      advanceTypes,
      deleteItem,
      idEdit,
      editItem,
      actionForm,
      changeStatus,
      pagination,
      changePage,
      changePerPage
    }
  }
})
